"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.humanDate = humanDate;
exports.humanTime = humanTime;
exports.humanDiff = humanDiff;
exports.humanDuration = humanDuration;

var _moment = _interopRequireWildcard(require("moment"));

var _config = require("../config/config");

function humanDate(datetime) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'LL';

  if (!datetime) {
    return;
  }

  var m = (0, _moment.isMoment)(datetime) ? datetime : (0, _moment.default)(datetime, 'YYYY-MM-DD HH:mm:ss');

  if (!m.isValid()) {
    return;
  }

  var date = m.format(format);

  switch (true) {
    case m.isSame((0, _moment.default)(), 'day'):
      return (0, _config.__)('Today');

    case m.isSame((0, _moment.default)().add(1, 'day'), 'day'):
      return (0, _config.__)('Tomorrow');

    case m.isSame((0, _moment.default)().subtract(1, 'day'), 'day'):
      return (0, _config.__)('Yesterday');

    case m > (0, _moment.default)().startOf('day').subtract(5, 'day') && m < (0, _moment.default)().endOf('day').add(5, 'day'):
      // 5 days offset from today
      return m.format('dddd');

    case m.isSame((0, _moment.default)(), 'year'):
      date = m.format(_moment.default.localeData().longDateFormat(format).replace(/\/?\.?YYYY\.?\/?/, '').split(',').map(function (item) {
        return item.trim();
      }).filter(function (item) {
        return !!item;
      }).join(', '));
      break;

    default:
      break;
  }

  return date;
}

function humanTime(datetime) {
  var withSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!datetime) {
    return;
  }

  var m = (0, _moment.isMoment)(datetime) ? datetime : (0, _moment.default)(datetime, 'YYYY-MM-DD HH:mm:ss');

  if (!m.isValid()) {
    return;
  }

  var date = humanDate(m, 'L');
  var time = m.format(withSeconds ? 'LTS' : 'LT');
  var result = new String(date + ', ' + time);
  result.date = date;
  result.time = time;
  return result;
}

function humanDiff(start) {
  var finish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!finish) {
    finish = Date.now();
  }

  return humanDuration(_moment.default.duration(finish - start));
}

function humanDuration(duration) {
  var units = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'seconds';

  var diff = _moment.default.duration(duration, units);

  switch (true) {
    case !!diff.years():
      return (0, _config.__n)('%d year', '%d years', diff.years());

    case !!diff.months():
      return (0, _config.__n)('%d month', '%d months', diff.months());

    case !!diff.weeks():
      return (0, _config.__n)('%d week', '%d weeks', diff.weeks());

    case !!diff.days():
      return (0, _config.__n)('%d day', '%d days', diff.days());

    case !!diff.hours():
      return (0, _config.__n)('%d hour', '%d hours', diff.hours());

    case !!diff.minutes():
      return (0, _config.__n)('%d minute', '%d minutes', diff.minutes());

    case !!diff.seconds():
    default:
      return (0, _config.__)('less than minute');
  }
}